import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button2 from '@embracesbs/component-button2/Button2'
import Icon from '@embracesbs/component-icon'
import { DEVELOPER_CENTER_PATH } from '../MainMenu/navigation'

interface BandBackButtonProps {
  /** Where the arrow goes. The developer tools are only linked from the
   *  Developer center, so that is the default. */
  to?: string
  label?: string
}

// The back arrow the dark 52px bands carry (DarkTabs, Terraform modules, Stage
// rollout). `tooltip` wires the global tooltip App.tsx renders, which is the
// only visible label an icon-only button gets; aria-label covers the rest.
const BandBackButton: React.FC<BandBackButtonProps> = ({ to = DEVELOPER_CENTER_PATH, label = 'Back to the developer center' }) => {
  const navigate = useNavigate()

  return (
    <Button2
      leftElement={<Icon iconName='ArrowLeft1' size={16} color='#ffffff' />}
      onClick={() => navigate(to)}
      text=''
      aria-label={label}
      tooltip={label}
      type='button'
      variant='subtle'
    />
  )
}

export default BandBackButton
